import { Component, OnInit } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';

@Component({
  selector: 'app-make-active-modal',
  imports: [TranslocoDirective],
  templateUrl: './make-active-modal.component.html',
  styleUrl: './make-active-modal.component.scss'
})
export class MakeActiveModalComponent extends ChangeStatusModalDirective implements OnInit {

  private textActivateVehicles: string;
  private textActiveVehicle: string;
  private textAuctionVehicles: string;
  private textAuctionVehicle: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textActivateVehicles;
    } else {
      return this.textActiveVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehicles.length > 1) {
      return this.textAuctionVehicles;
    } else {
      return this.textAuctionVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeActiveModal')
      .subscribe(translate => {
        this.textActivateVehicles = translate.textActivateVehicles;
        this.textActiveVehicle = translate.textActiveVehicle;
        this.textAuctionVehicles = translate.textAuctionVehicles;
        this.textAuctionVehicle = translate.textAuctionVehicle;
      });
  }
}
